import { usePageContext } from 'vike-react/usePageContext';
import { BrowserRouter, StaticRouter } from 'react-router';

import { initializeGoogleTag } from '@/features/analytics/googleTag';

import App from '../../App';
import '../../index.css';

initializeGoogleTag();

export const Page = () => {
  const pageContext = usePageContext();
  const { urlPathname } = pageContext;

  if (typeof window !== 'undefined') {
    return (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    );
  }

  return (
    <StaticRouter location={urlPathname}>
      <App />
    </StaticRouter>
  );
};
